import React from 'react';
import ExternalSystemEdit from '../ExternalSystemEdit';
import { GmailImporter } from './gmailImporter';

ExternalSystemEdit.registerCustomRenderer('GmailImporter', ({ parentProps }) => (<GmailImporter {...parentProps} />));
